import {
	Button,
	Text
} from '@shopify/polaris'
import React from 'react'
import Xero from '../../../../img/integrations/xero_icon.png'
import Google from '../../../../img/logos/google-logo.svg'
import { getResponseErrorMessage } from '../../../../utils/errors'

const LoginButtons = () => {

	const handleXeroLogin = async () => {
		const baseUrl = process.env.REACT_APP_API_URL || "";
		const isDev = baseUrl.includes('dev');
		const basicURL = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}/api/1/login/xero/`;

		try {
			const res1 = await fetch(basicURL, {
				method: "GET",
				mode: "cors",
			});
			if (!res1.ok) {
				throw new Error(await getResponseErrorMessage(res1));
			}

			const data = await res1.json();

			if (data.redict_url) {
				const redirectURL = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}${data.redict_url}`;
				window.location.href = redirectURL;
			} else {
				console.error("redict_url not found in response");
			}
		} catch (err) {
			console.error("Error during request:", err);
		}
	};

	const handleGoogleLogin = async () => {
		localStorage.setItem('showGoogleModal', 'true');
		const baseUrl = process.env.REACT_APP_API_URL || "";
		const isDev = baseUrl.includes('dev');
		const backendUrl = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}/api/1/login/google/`;

		try {
			const res = await fetch(backendUrl, {
				method: "GET",
				mode: "cors",
			});
			if (!res.ok) {
				throw new Error(await getResponseErrorMessage(res));
			}
			const data = await res.json();

			if (data.redict_url) {
				const googleAuthUrl = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}${data.redict_url}`;
				window.location.href = googleAuthUrl;
			} else {
				console.error("No redirect URL in response");
			}
		} catch (err) {
			console.error("Error fetching Google login URL:", err);
		}
	};

	return (
			<div style={{marginTop: 40,}}>
				<div >
					<div style={{padding: 0}}>
						<div
								style={{
									textAlign: 'center',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center'
								}}
						>
							<div
									style={{
										width: '50%',
										height: 2,
										backgroundColor: 'rgb(213, 220, 224)',
										marginRight: 20
									}}
							></div >
							<Text
									variant='headingMd'
									as='h2'
							>
								OR
							</Text >
							<div
									style={{
										width: '50%',
										height: 2,
										backgroundColor: 'rgb(213, 220, 224)',
										marginLeft: 20
									}}
							></div >
						</div >

						<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									gap: '16px',
									marginTop: 20
								}}
						>
							<Button
									fullWidth
									variant='secondary'
									onClick={handleXeroLogin}
							>

								<img
										src={Xero}
										alt='Xero'
										style={{
											width: 35,
											height: 35
										}}
								/>
								Sign in with Xero
							</Button >

							<Button
									fullWidth
									variant='secondary'
									onClick={handleGoogleLogin}
							>
								<img
										src={Google}
										alt='Google'
										style={{
											width: 'auto',
											height: 12,
											marginRight: 5
										}}
								/>
								Sign in with Google

							</Button >

						</div >
					</div >
				</div >
			</div >
	)
}

export default LoginButtons
